<template>
  <BittsTabs
    :current-value="currentTab"
    :tabs="IRP_TABS"
    :full-width="false"
    data-testid="irp-tab-bar"
    @change:tab="(tab) => emit('change:tab', tab)"
  >
    <template #labelSuffix="{ value }">
      <BittsCount
        v-if="counts[value]"
        :count="counts[value]"
        type="neutral"
        class="ml-4 mt-2"
      />
    </template>
  </BittsTabs>
</template>

<script setup lang="ts">
import { BittsCount, BittsTabs } from '@crossbeam/bitts';

import { type IRPTabType, IRP_TABS } from './irp';

type Props = {
  currentTab: IRPTabType;
  counts?: Partial<Record<IRPTabType, number>>;
};

const { currentTab, counts = {} } = defineProps<Props>();

const emit = defineEmits<{
  'change:tab': [tab: IRPTabType];
}>();
</script>

<style scoped lang="pcss">
@reference "../../../css/theme.css";
.bitts-simple-tabs {
  @apply border-b-2 border-neutral-background-disabled;
}
</style>
